import React from 'react'

function Screen_size() {
  return (
<>
<h2>Screen Size</h2>
<br/>
<p className='p-doc'>small(0-576 px)</p>
<code>sm</code>
<br/>
<br/>
<p className='p-doc'>medium(577-768 px)</p>
<code>md</code>
<br/>
<br/>
<p className='p-doc'>large(769-992 px)</p>
<code>sm</code>
<br/>
<br/>
<p className='p-doc'>extra large(993-max px)</p>
<code>xl</code>
<br/>
<br/>

</>
  )
}

export default Screen_size